import { render, staticRenderFns } from "./button-bar.vue?vue&type=template&id=a71c7860"
import script from "./button-bar.vue?vue&type=script&lang=js"
export * from "./button-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports